module.exports = {
	localize: localize
}
var dict = {
	en: (window.dictionary || {}).en || {},
	[window.lang]: (window.dictionary || {}).currentLang || {},
}
var en = $.extend({}, dict.en);
var currentLang = $.extend({}, dict[window.lang]);

function localize (exp, params) {
	var lang = $('html').attr('lang') || 'en';

	var result = '';
	if (typeof (exp) === 'string') {
		if (lang === window.lang) {
			if (currentLang[exp]) {
				result = currentLang[exp];
			} else {
				result = en[exp] || exp;
			}
		} else {
			result = en[exp] || exp;
		}
	}
	return replaceParams(result, params);
}

function replaceParams (translated, params) {
	var result = translated;
	if (typeof translated === 'string' && Array.isArray(params)) {
		for (var i in params) {
			result = result.replace(new RegExp('\\{' + String(i) + '\\}', 'g'), params[i]);
		}
	}
	return result;
}



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/i18n.js